import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './App.css'

function App() {
  const [activeSection, setActiveSection] = useState('banner')
  const location = useLocation()

  useEffect(() => {
    // 处理从其他页面返回时的滚动
    const hash = location.hash.slice(1); // 移除#号
    if (hash) {
      const section = document.querySelector(`.${hash}`);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location])

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['banner', 'company-profile', 'solutions', 'advantages', 'footer']
      const sectionElements = sections.map(id => ({
        id,
        element: document.querySelector(`.${id}`),
      }))

      const currentSection = sectionElements.find(({ element }) => {
        if (!element) return false
        const rect = element.getBoundingClientRect()
        return rect.top <= 100 && rect.bottom >= 100
      })

      if (currentSection) {
        setActiveSection(currentSection.id)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="app">
      {/* 导航栏 */}
      <nav className="navbar">
        <div className="logo">
          <img src="/src/img/xzclogo.png" alt="公司logo" />
        </div>
        <ul className="nav-links">
          <li 
            className={activeSection === 'banner' ? 'active' : ''}
            onClick={() => document.querySelector('.banner').scrollIntoView({ behavior: 'smooth' })}
          >网站首页</li>
          <li 
            className={activeSection === 'company-profile' ? 'active' : ''}
            onClick={() => document.querySelector('.company-profile').scrollIntoView({ behavior: 'smooth' })}
          >公司简介</li>
          <li 
            className={activeSection === 'solutions' ? 'active' : ''}
            onClick={() => document.querySelector('.solutions').scrollIntoView({ behavior: 'smooth' })}
          >解决方案</li>
          <li 
            className={activeSection === 'advantages' ? 'active' : ''}
            onClick={() => document.querySelector('.advantages').scrollIntoView({ behavior: 'smooth' })}
          >产品优势</li>
          <li 
            className={activeSection === 'footer' ? 'active' : ''}
            onClick={() => document.querySelector('.footer').scrollIntoView({ behavior: 'smooth' })}
          >联系我们</li>
        </ul>
      </nav>

      {/* 主横幅 */}
      <div className="banner">
        <h1>智慧校园建设丨教育科技深度融合</h1>
      </div>

      {/* 公司简介 */}
      <section className="company-profile">
        <h2>公司简介<span>COMPANY PROFILE</span></h2>
        <div className="profile-content">
          <p>四川学教创科技有限公司</p>
          <p>专注于智慧校园建设企业，致力于推进四川省教育信息化2.0发展的一支中坚力量。公司研发的云一卡通、一号通、校园AI、智慧教室、智慧宿舍、智慧门禁、智慧食堂等一系列产品，已一站式服务了多家学校。是一家以计算机软硬件开发为主，开发应用软件为辅，为客户提供优质的产品和服务。</p>
        </div>
      </section>

      {/* 解决方案 */}
      <section className="solutions">
        <h2>解决方案<span>TOTAL SOLUTION</span></h2>
        <div className="service-types">
          <div className="service-item">
            <a href="/student-service"><h3>学生服务</h3></a>
          </div>
          <div className="service-item">
            <a href="/teacher-service"><h3>教师服务</h3></a>
          </div>
          <div className="service-item">
            <a href="/department-service"><h3>部门服务</h3></a>
          </div>
          <div className="service-item">
            <a href="/leader-service"><h3>领导服务</h3></a>
          </div>
        </div>
        <div className="smart-services">
          <Link to="/smart-education" className="smart-service-item">
            <img src="/src/img/zhjy.png" alt="智慧教育" />
            <h4>智慧教育</h4>
            <p>通过数字化平台提供综合的学生成长、校园资源服务，在线教育平台建设集成。</p>
          </Link>
          <Link to="/smart-service" className="smart-service-item">
            <img src="/src/img/zhfw.png" alt="智慧服务" />
            <h4>智慧服务</h4>
            <p>通过一键上课、门禁考勤、智能监考等服务模块，打造高效课堂，实现教学过程智能化管理。</p>
          </Link>
          <Link to="/smart-office" className="smart-service-item">
            <img src="/src/img/zybg.png" alt="智慧办公" />
            <h4>智慧办公</h4>
            <p>以信息化平台为依托的行政办公系统，高效化办公，简化部门工作流。</p>
          </Link>
          <Link to="/smart-support" className="smart-service-item">
            <img src="/src/img/zhzc.png" alt="智慧支撑" />
            <h4>智慧支撑</h4>
            <p>提供全方位的技术支持和服务保障，确保系统稳定运行和持续优化。</p>
          </Link>
          <Link to="/smart-management" className="smart-service-item">
            <img src="/src/img/zhgl.png" alt="智慧管理" />
            <h4>智慧管理</h4>
            <p>实现校园管理的智能化和数字化，提高管理效率和决策水平。</p>
          </Link>
          <Link to="/smart-ai" className="smart-service-item">
            <img src="/src/img/zhai.png" alt="智慧AI" />
            <h4>智慧AI</h4>
            <p>运用人工智能技术，为教育教学和校园管理提供智能化解决方案。</p>
          </Link>
        </div>
      </section>

      {/* 产品优势 */}
      <section className="advantages">
        <h2>产品优势<span>PRODUCT ADVANTAGES</span></h2>
        <div className="advantage-grid">
          <div className="advantage-item">
            <img src="/src/img/ksxy.png" alt="快速响应" />
            <div className="content">
              <h3>快速响应</h3>
              <p>创新的代码架构与动力，高效运行，优化完整化实现。</p>
            </div>
          </div>
          <div className="advantage-item">
            <img src="/src/img/xcsp.png" alt="信创适配" />
            <div className="content">
              <h3>信创适配</h3>
              <p>信创适配完整度100%，完全一体化适配，所有业务完全适配。</p>
            </div>
          </div>
          <div className="advantage-item">
            <img src="/src/img/tyjc.png" alt="统一集成" />
            <div className="content">
              <h3>统一集成</h3>
              <p>统一平台与统一的应用入口，统一一个平台，统一化的操作界面。</p>
            </div>
          </div>
          <div className="advantage-item">
            <img src="/src/img/dbrz.png" alt="专业认证" />
            <div className="content">
              <h3>专业认证</h3>
              <p>专业平台与专业的资质认证，全国各大高校一致认可，符合国家标准。</p>
            </div>
          </div>
        </div>
      </section>

      {/* 合作院校 */}
      <section className="partners">
        <h2>合作院校<span>PARTNERS</span></h2>
        <div className="partner-grid">
          <img src="/src/img/gazylogo.png"  />
          <img src="/src/img/ablogo.png"  />
          <img src="/src/img/dzzylogo.png"  />
          <img src="/src/img/xnykdlogo.png"  />
        </div>
      </section>

      {/* 页脚 */}
      <footer className="footer">
        <div className="contact-info">
          <p>公司地址：四川省成都市双流区富森美天府直播港14栋801</p>
          <p>联系电话：</p>
          <p>邮箱地址：</p>
        </div>
      </footer>
    </div>
  )
}

export default App
